<template>
    <div>
        <slot name="prepend"></slot>
        <form-field caption="Choix du terrain pour cette épreuve">
            <field-selector
                :competition_id="d_competition_id"
                :round_number="d_round_number"
                :level="d_level"
                :category="d_category"
                :eventType="d_event_type"
            ></field-selector>
        </form-field>
        <slot name="afterField"></slot>
        
    </div>
</template>

<script>
import FormField from '../../../../components/Panels/FormField.vue'
import FieldSelector from './FieldSelector.vue'

export default{
    components: { FormField, FieldSelector },
    props:{
        competition_id: { type:String, required:true},
        round_number: {type:Number, required:true},
        level: { type:String, required:true},
        category: { type:String, required: true},
        eventType: { type:String, required:true},
    },
    data(){
        return {
            d_competition_id: this.competition_id,
            d_eventType: this.eventType,
            d_category: this.category,
            d_level: this.level,
            d_round_number: this.round_number,
        };
    }
}
</script>
